import 'js/src/libs/set-webpack-nonce';
import 'js/src/libs/page-initialization';

import EmbedVideoPage from 'js/src/components/embed-video';
import { getRootReducer } from 'js/src/entry-points/root-reducers/embed-video-reducers';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { createReduxStore, renderWithRedux } from 'js/src/libs/redux-utils';

ErrorReporter.init(Project.FRONTEND);

const store = createReduxStore(getRootReducer());

renderWithRedux(EmbedVideoPage, store);
